const Joi = require('joi');

const validateEndDateNotInPast = (value, helpers) => {
  const today = new Date().toISOString().slice(0, 10);
  if (value < today) {
    return helpers.error('date.past', { v: value });
  }
  return value;
};

const validateDateRange = (value, helpers) => {
  const { startDate, endDate } = helpers.state.ancestors[0];

  // If only one field - we cannot do check
  if (!startDate || !endDate) {
    return value;
  }

  if (endDate < startDate) {
    return helpers.error('date.greater', { v: value });
  }

  return value;
};

const QRCodeSchema = Joi.object({
    startDate: Joi.string()
        .pattern(/^\d{4}-\d{2}-\d{2}$/)
        .required()
        .messages({
            'string.pattern.base': 'Start date must be in format YYYY-MM-DD',
        })
        .label('Start Date'),
    endDate: Joi.string()
        .pattern(/^\d{4}-\d{2}-\d{2}$/)
        .required()
        .custom(validateEndDateNotInPast)
        .custom(validateDateRange)
        .messages({
            'string.pattern.base': 'End date must be in format YYYY-MM-DD',
            'date.past': 'End date cannot be in the past',
            'date.greater': 'End date must be greater than or equal to start date'
        })
        .label('End Date'),
    amount: Joi.number()
        .required()
        .min(0)
        .label('Amount'),
    enabled: Joi.boolean()
        .default(true),
    createdAt: Joi.date().optional()
});

const validateQRCode = (data) => {
    return QRCodeSchema.validate(data);
};

module.exports = { validateQRCode };

